import * as Yup from 'yup'

/* form value types */
export type ThreadFormValues = {
  type: ThreadType | ''
  text: string
  attachments: { id: string }[]
}

export type MessageFormValues = {
  text: string
  attachments: { id: string }[]
}

/* yup schema */
export const threadValidationSchema = (role: UserRole) =>
  Yup.object({
    ...(['writer', 'editor'].includes(role) && {
      type: Yup.string().required('Query type is required')
    }), // type is not required in business portal
    text: Yup.string().trim().nullable(),
    attachments: Yup.array().when('text', {
      is: value => !value || value.trim() === '',
      then: Yup.array()
        .min(1, 'Comment or Attachment either of field is required')
        .of(
          Yup.object({
            id: Yup.string().required()
          })
        )
        .required('Please select attachment'),
      otherwise: Yup.array().of(
        Yup.object({
          id: Yup.string().required()
        })
      )
    })
  })

export const messageValidationSchema = Yup.object({
  text: Yup.string().trim().nullable(),
  attachments: Yup.array().when('text', {
    is: value => !value || value.trim() === '',
    then: Yup.array()
      .min(1, 'Comment or Attachment either of field is required')
      .of(
        Yup.object({
          id: Yup.string().required()
        })
      )
      .required('Please select attachment'),
    otherwise: Yup.array().of(
      Yup.object({
        id: Yup.string().required()
      })
    )
  })
})
